import { render } from "./ComponentProvider.vue?vue&type=template&id=8b4e6b52"
import script from "./ComponentProvider.vue?vue&type=script&lang=js"
export * from "./ComponentProvider.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__